import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CrmModelDrivenFormErrorComponent } from '../model-driven-form-error/model-driven-form-error.component';
import { FieldWarningService } from '../model-driven-form-error/field-warning.service';
import { stopChromeAutofill } from '../stop-chrome-autofill';
import { ObjectType } from '../../../../tokens-and-interfaces';
import { FieldValidation } from '../../field-validation';
import { InlineEditService } from '../../inline-edit.service';

@Component({
  templateUrl: './float.html',
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    DigitOnlyModule,
    TranslateModule,
    GalaxyFormFieldModule,
    CrmModelDrivenFormErrorComponent,
  ],
  providers: [FieldWarningService],
  styleUrls: ['../renderers.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatRendererComponent {
  fieldId!: string;
  objectType!: ObjectType;
  control!: FormControl<number>;
  label!: string;
  validation!: FieldValidation;
  readOnly!: boolean;

  disableAutoComplete: string = stopChromeAutofill();

  constructor(private readonly inlineEditService: InlineEditService) {}

  saveField(): void {
    this.inlineEditService.saveInlineEdit(this.objectType, [
      {
        fieldId: this.fieldId,
        floatValue: this.control.value,
      },
    ]);
  }
}
